import {getComponent} from "../jsbase/utils";
import {on} from "../jsbase/events";

export default {
    args: 'url',
    url: null,
    filterFieldEls: null,
    filterParams: null,
    pagingEl: null,
    sortColumns: [],

    props: {
        url: String,
        paging: String,
        filterFields: String,
        filterParams: String,
        loadManually: Boolean,
    },

    data: {
        targetEl: null,
    },

    connect() {
        this.data.targetEl = this.el;
        this.filterFieldEls = [];
        if (this.filterFields) {
            this.filterFields.split(',').forEach(item => {
                let el = document.querySelector(item.trim());
                this.filterFieldEls.push(el);
                on(el, 'blur', () => {
                    if (el.value !== el.getAttribute('data-value')) {
                        el.setAttribute('data-value', el.value);
                        this.load();
                    }
                });
                on(el, 'keydown', (ev) => {
                    if (ev.key === 'Enter' && el.value !== el.getAttribute('data-value')) {
                        el.setAttribute('data-value', el.value);
                        this.load();
                    }
                });
            });
        }

        if (this.filterParams) {
            var paramsString = this.filterParams;
            this.filterParams = {};
            paramsString.split('&').forEach(param => {
                let p = param.split('=');
                this.filterParams[p[0]] = p[1];
            });
        } else {
            this.filterParams = {};
        }
        // if (this.el.id && useroptions.getUserOption(`sort-${this.el.id}`)) {
        //     try {
        //         var sortOption = JSON.parse(useroptions.getUserOption(`sort-${this.el.id}`) || '{}');
        //     } catch (e) {}
        //     this.filterParams["SortBy"] = sortOption?.sortBy || null;
        //     this.filterParams["Sort"] = sortOption?.sort || 1;
        // }
    },

    inited() {
        if (this.data.targetEl && this.loadManually !== true) {
            this.load();
        }
    },

    methods: {
        getPaging() {
            if (this.paging && !this.pagingEl) {
                this.pagingEl = getComponent(document.querySelector(this.paging), 'ajax-paging');
            }
            return this.pagingEl;
        },
        load() {
            $(this.data.targetEl).applyLoader(true, "Lade Daten ...");
            let data = { };
            if (this.getPaging()) {
                $.extend(data, this.getPaging().getPagingFilter());
            }
            if (this.filterParams) {
                $.extend(data, this.filterParams);
            }
            this.filterFieldEls.forEach(el => {
                data[el.getAttribute("name")] = el.value;
            });
            connection.getJson(this.url, {
                data: data,
            }).done(data => {
                if (this.getPaging()) {
                    this.getPaging().update(data);
                }

                this.data.targetEl.innerHTML = data.content;
                onContentReady($(this.data.targetEl));
                $(this.data.targetEl).hideLoader();
                this.refreshSortColumns();
            });
        },
        refreshSortColumns() {
            this.sortColumns = this.el.querySelectorAll('[data-sort]');
            this.sortColumns.forEach(el => {
                on(el, 'click', (ev) => {
                    this.filterParams["SortBy"] = ev.target.dataset.sort;
                    this.filterParams["Sort"] = this.filterParams["Sort"] === 1 ? 2 : 1;
                    el.dataset.sortOrder = this.filterParams["Sort"];
                    // if (this.el.id) {
                    //     useroptions.addUserOption(
                    //         `sort-${this.el.id}`,
                    //         JSON.stringify({ sortBy: this.filterParams["SortBy"], sort: this.filterParams["Sort"] })
                    //     );
                    // }
                    this.load();
                });
                if (el.dataset.sort === this.filterParams["SortBy"]) {
                    el.dataset.sortOrder = this.filterParams["Sort"];
                }
            });
        },
    }

}
